export const GET_CART_ITEMS_LIST = "GET_CART_ITEMS_LIST";
export const GET_CART_ITEMS_LIST_SUCCESS = "GET_CART_ITEMS_LIST_SUCCESS";
export const GET_CART_ITEMS_LIST_FAILED = "GET_CART_ITEMS_LIST_FAILED";
export const DELETE_CART_ITEMS_LIST = "DELETE_CART_ITEMS_LIST";
export const DELETE_CART_ITEMS_LIST_SUCCESS = "DELETE_CART_ITEMS_LIST_SUCCESS";
export const DELETE_CART_ITEMS_LIST_FAILED = "DELETE_CART_ITEMS_LIST_FAILED";
export const ADD_TO_CART = "ADD_TO_CART";
export const ADD_TO_CART_SUCCESS = "ADD_TO_CART_SUCCESS";
export const ADD_TO_CART_FAILED = "ADD_TO_CART_FAILED";

export const APPLY_OFFER_CODE = "APPLY_OFFER_CODE";
export const APPLY_OFFER_CODE_SUCCESS = "APPLY_OFFER_CODE_SUCCESS";
export const APPLY_OFFER_CODE_FAILED = "APPLY_OFFER_CODE_FAILED";

export const FETCH_CART_ITEM = "FETCH_CART_ITEM";
export const FETCH_CART_ITEM_SUCCESS = "FETCH_CART_ITEM_SUCCESS";
export const FETCH_CART_ITEM_FAILED = "FETCH_CART_ITEM_FAILED";
export const DELETE_CART_ITEM = "DELETE_CART_ITEM";
export const DELETE_CART_ITEM_SUCCESS = "DELETE_CART_ITEM_SUCCESS";
export const DELETE_CART_ITEM_FAILED = "DELETE_CART_ITEM_FAILED";
export const UPLOAD_CART_IMAGES = "UPLOAD_CART_IMAGES";
export const UPLOAD_CART_IMAGES_SUCCESS = "UPLOAD_CART_IMAGES_SUCCESS";
export const UPLOAD_CART_IMAGES_FAILED = "UPLOAD_CART_IMAGES_FAILED";

export const AVAILABLE_DATES = "AVAILABLE_DATES";
export const AVAILABLE_DATES_SUCCESS = "AVAILABLE_DATES_SUCCESS";
export const AVAILABLE_DATES_FAILED = "AVAILABLE_DATES_FAILED";
export const AVAILABLE_SLOTS = "AVAILABLE_SLOTS";
export const AVAILABLE_SLOTS_SUCCESS = "AVAILABLE_SLOTS_SUCCESS";
export const AVAILABLE_SLOTS_FAILED = "AVAILABLE_SLOTS_FAILED";

export const BOOKING_IMAGE = "BOOKING_IMAGE";
export const BOOKING_IMAGE_SUCCESS = "BOOKING_IMAGE_SUCCESS";
export const BOOKING_IMAGE_FAILED = "BOOKING_IMAGE_FAILED";

export const GET_MULTI_SERVICE_DETAILS = "GET_MULTI_SERVICE_DETAILS";
export const GET_MULTI_SERVICE_DETAILS_SUCCESS = "GET_MULTI_SERVICE_DETAILS_SUCCESS";
export const GET_MULTI_SERVICE_DETAILS_FAILED = "GET_MULTI_SERVICE_DETAILS_FAILED";

export const DELETE_CART_IMAGE = "DELETE_CART_IMAGE";
export const DELETE_CART_IMAGE_SUCCESS = "DELETE_CART_IMAGE_SUCCESS";
export const DELETE_CART_IMAGE_FAILED = "DELETE_CART_IMAGE_FAILED";

export const UPDATE_CART_ITEM = "UPDATE_CART_ITEM";
export const UPDATE_CART_ITEM_SUCCESS = "UPDATE_CART_ITEM_SUCCESS";
export const UPDATE_CART_ITEM_FAILED = "UPDATE_CART_ITEM_FAILED";
export const STORE_CITY_SUCCESS = "STORE_CITY_SUCCESS";
export const SAVE_SERVICE_DATA = "SAVE_SERVICE_DATA";
export const INSERT_IMAGE_INTO_CART = "INSERT_IMAGE_INTO_CART";
export const DELETE_IMAGE_FROM_CARTIMAGES = "DELETE_IMAGE_FROM_CARTIMAGES";
